import { backToTopLauncher } from '../../exports/backToTopLauncher';

export function loadWidgetButtons(isTextToTopEnabled) {
    return import(
        /* webpackChunkName: "chat" */
        './chat'
    ).then(({ default: chat }) => {
        chat.start();
        if (chat.shouldLoadChat()) {
            // Make room for Intercom Chat Widget, since we show chat widget
            backToTopLauncher({ isCopyEnabled: isTextToTopEnabled, showChatWidget: true });
        } else {
            // Pin Back to Top button to bottom, since we don't show chat widget
            backToTopLauncher({ isCopyEnabled: isTextToTopEnabled, showChatWidget: false });
        }
    });
}
